// extracted by mini-css-extract-plugin
export default {"card":"styles_card__nNCg1","tableDadosAtividade":"styles_tableDadosAtividade__urqJA","tableArquivo":"styles_tableArquivo__WA3ra","containerBtts":"styles_containerBtts__+QMt1"};